import React from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useAuth } from '../../modules/auth/contexts/AuthContext'
import { createLoginRedirectUrl } from '../../utils/navigationHelpers'
import { UserRole } from '../../types/api'

const ADMIN_ROLE: UserRole = 'ADMIN'

interface CheckoutRouteProps {
  children: React.ReactNode
}

/**
 * Guard para a página de checkout:
 * - Usuário não logado → redireciona para login com redirect de volta ao checkout
 * - Usuário logado como ADMIN → exibe mensagem na tela e botão para voltar
 */
const CheckoutRoute: React.FC<CheckoutRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth()
  const navigate = useNavigate()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4" aria-hidden />
          <p className="text-gray-600">Verificando autenticação...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to={createLoginRedirectUrl('/checkout')} replace />
  }

  if (user?.role === ADMIN_ROLE) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-sm p-8 max-w-md w-full text-center">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Acesso restrito</h2>
          <p className="text-gray-600 mb-6">
            O checkout é apenas para clientes. Contas de administrador não podem finalizar compras.
          </p>
          <button
            type="button"
            onClick={() => navigate('/')}
            className="w-full py-3 px-4 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
          >
            Voltar
          </button>
        </div>
      </div>
    )
  }

  return <>{children}</>
}

export default CheckoutRoute
